import { NgModule } from '@angular/core';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzListModule} from 'ng-zorro-antd/list';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@NgModule({
    exports: [
        NzMenuModule,
        NzLayoutModule,
        NzIconModule,
        NzCarouselModule,
        NzGridModule,
        NzButtonModule,
        NzBreadCrumbModule,
        NzCardModule,
        NzPageHeaderModule,
        NzDrawerModule,
        NzSpaceModule,
        NzDividerModule,
        NzSelectModule,
        NzFormModule,
        NzInputModule,
        NzListModule,
        NzBadgeModule,
        NzTagModule,
        NzNotificationModule,
        NzEmptyModule,
        NzPaginationModule,
        NzTabsModule
    ],
    
})

export class NgZorroAntdModule {
    
}